/**
 * @description Define constantes relacionadas con los archivos multimedia, como los tipos MIME permitidos y el tamaño máximo de los archivos.
 * - Estas constantes se utilizan para validar los archivos que los usuarios intentan cargar, asegurando que cumplan con los requisitos de formato y tamaño establecidos por la aplicación.
 */
export const FILE_ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/jpeg',
  'image/png',
] as const;

/**
 * @description Define el tamaño máximo permitido para los archivos que se pueden cargar en la aplicación, expresado en megabytes (MB).
 * - Esta constante se utiliza para validar el tamaño de los archivos durante el proceso de carga, asegurando que los usuarios no intenten cargar archivos que excedan el límite establecido, lo que podría afectar el rendimiento y la experiencia del usuario.
 */
export const FILE_MAX_SIZE_MB = 5;